module.exports = __webpack_public_path__ + "img/characteristic-5.a777d0b6.png";